<template>
  <div class="countdown-section" v-if="visible">
    <div class="countdown-wrapper">
      <span class="countdown-title">{{ title }}</span>
      <div class="countdown-display">
        <span class="time-block">{{ minutes }}</span>
        <span class="time-colon">分</span>
        <span class="time-block">{{ seconds }}</span>
        <span class="time-colon">秒</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CountdownTimer',
  props: {
    config: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      remainingTime: 0,
      timer: null
    }
  },
  computed: {
    visible() {
      return this.config.visible !== false
    },
    title() {
      return this.config.title || '会员优惠活动距离结束仅剩：'
    },
    duration() {
      // 默认10分钟，可以从配置读取（单位：秒）
      return this.config.duration || 10 * 60
    },
    minutes() {
      return String(Math.floor(this.remainingTime / 60)).padStart(2, '0')
    },
    seconds() {
      return String(this.remainingTime % 60).padStart(2, '0')
    }
  },
  mounted() {
    this.initCountdown()
  },
  beforeDestroy() {
    this.clearTimer()
  },
  methods: {
    initCountdown() {
      // 如果有配置结束时间，计算剩余时间
      if (this.config.endTime) {
        const end = new Date(this.config.endTime).getTime()
        const now = new Date().getTime()
        const diff = Math.floor((end - now) / 1000)
        this.remainingTime = diff > 0 ? diff : this.duration
      } else {
        this.remainingTime = this.duration
      }
      this.startCountdown()
    },
    startCountdown() {
      this.clearTimer()
      this.timer = setInterval(() => {
        if (this.remainingTime > 0) {
          this.remainingTime--
        } else {
          this.clearTimer()
          // 倒计时结束，可以重置或触发其他逻辑
          if (this.config.autoReset !== false) {
            this.remainingTime = this.duration
            this.startCountdown()
          }
          // 触发结束事件
          this.$emit('action', { type: 'countdownEnd' })
        }
      }, 1000)
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    }
  }
}
</script>

<style lang="less" scoped>
.countdown-section {
  width: 100%;
  padding: 0.1rem;
  margin: -0.3rem 0 0.2rem;
  display: flex;
  justify-content: center;
}

.countdown-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.15rem;
  flex-wrap: nowrap;
  white-space: nowrap;
}

.countdown-title {
  font-size: 0.28rem;
  color: rgba(0, 106, 255, 0.9);
}

.countdown-display {
  display: flex;
  align-items: center;
  gap: 0.08rem;
}

.time-block {
  min-width: 0.5rem;
  height: 0.5rem;
  background: #fff;
  border-radius: 0.1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.32rem;
  font-weight: 600;
  color: #000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.time-colon {
  font-size: 0.26rem;
  color: rgba(0, 106, 255, 0.9);
  margin: 0 0.05rem;
}
</style>
